
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getApplicationStatus} from 'sr/utils/api/masterData/applicationStatus/getApplicationStatus'
export const fetchapplicationStatus = createAsyncThunk(
  'getApplicationStatus',
  async () => {
    const response = await getApplicationStatus()
    return response?.data
  }
)


